import { http } from "../base"

// 获取加油包列表
export async function getFuelPackages() {
    try {
        const response = await http.get(
            `/aics/fuel_package/list`
        )
        return response
    } catch (error) {
        console.error("获取加油包列表失败:", error)
        throw error
    }
}

// 获取购物车列表
export async function getCartItems() {
    try {
        const response = await http.get(
            `/aics/cart/list`
        )
        return response
    } catch (error) {
        console.error("获取购物车失败:", error)
        throw error
    }
}

// 添加到购物车
export async function addToCart(cartItem) {
    console.log("addToCart",cartItem);
    try {
        const response = await http.post(
            `/aics/cart/add`,
            cartItem
        )
        return response
    } catch (error) {
        console.error("添加到购物车失败:", error)
        throw error
    }
}

// 更新购物车项
export async function updateCartItem(cartItem) {
    console.log("updateCartItem", cartItem);
    try {
        const response = await http.post(
            `/aics/cart/update`,
            cartItem
        )
        return response
    } catch (error) {
        console.error("更新购物车失败:", error)
        throw error
    }
}

// 移除购物车项
export async function removeCartItem(id) {
    try {
        const response = await http.delete(
            `/aics/cart/remove/${id}`
        )
        return response
    } catch (error) {
        console.error("移除购物车项失败:", error)
        throw error
    }
}

// 清空购物车
export async function clearCart() {
    try {
        const response = await http.post(
            `/aics/cart/clear`
        )
        return response
    } catch (error) {
        console.error("清空购物车失败:", error)
        throw error
    }
}

// 获取购物车总价
export async function getCartTotal() {
    try {
        const response = await http.get(
            `/aics/cart/total`
        )
        return response
    } catch (error) {
        console.error("获取购物车总价失败:", error)
        throw error
    }
}

// 获取优惠活动
export async function listPromotions() {
    try {
        const response = await http.get(
            `/aics/cart/list_promotions`
        )
        return response
    } catch (error) {
        console.error("获取优惠活动失败:", error)
        throw error
    }
} 

// 计算优惠活动
export async function calculatePromotions() {
    try {
        // 调用统一接口
        const response = await http.get('/aics/cart/unified-price');
        return response;
    } catch (error) {
        console.error("计算优惠活动失败:", error);
        throw error;
    }
}